module.exports = __webpack_public_path__ + "img/back-disabled.94717071.svg";